<template>
  <div>
    <input type="number" class="form-control" @input="updateBurnRate"
      v-if="isAdmin || isFromAuthUser"
      :value="(burnRate.rate / 100)"
      placeholder="avg burnrate"
      style="min-width: 100px;"
    >
    <div class="text-right" v-else v-text="(burnRate.rate / 100)" />
  </div>
</template>

<script>
  export default {
    props: ['burnRate', 'type'],
    data() {
      return {
        isAdmin: window.isAdmin,
        isFromAuthUser: window.isFromAuthUser,
      }
    },
    methods: {
      updateBurnRate: _.debounce(function(event) {
        const rate = event.target.value.replace(',', '.') * 100
        this.$emit('burnRateUpdated', {burnRate: this.burnRate, rate})
        if (this.type === 'trial') {
          axios.put(`/trials/${this.burnRate.productable_id}/burn_rates/${this.burnRate.id}`, {rate}).then(({data}) => {
            window.notification.success('Burnrate has been saved', 'Success!')
          })
        } else {
          axios.put(`/roll_outs/${this.burnRate.productable_id}/burn_rates/${this.burnRate.id}`, {rate}).then(({data}) => {
            window.notification.success('Burnrate has been saved', 'Success!')
          })
        }
      }, 250),
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/BurnRateInput.vue